module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "desktop-main",
    attrs: {
      "element-loading-text": "正在加载中，请稍后。。。"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.downloading),
      expression: "downloading"
    }],
    staticClass: "admin-body",
    attrs: {
      "element-loading-text": "图片正在生成中，请稍后。。。"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.tableParams,
      "label-width": "80px",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入用户手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.tableParams.orderUserPhone),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "orderUserPhone", $$v)
      },
      expression: "tableParams.orderUserPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "编号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入订单编号",
      "clearable": ""
    },
    model: {
      value: (_vm.tableParams.orderCode),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "orderCode", $$v)
      },
      expression: "tableParams.orderCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择订单状态",
      "clearable": ""
    },
    model: {
      value: (_vm.tableParams.orderStatus),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "orderStatus", $$v)
      },
      expression: "tableParams.orderStatus"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": "待付款",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    key: 1,
    attrs: {
      "label": "已付款",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    key: 4,
    attrs: {
      "label": "退款中",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "已退款",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    key: 3,
    attrs: {
      "label": "超时关闭",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.tableParams.createdTimes),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "createdTimes", $$v)
      },
      expression: "tableParams.createdTimes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "付款时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.tableParams.payTimes),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "payTimes", $$v)
      },
      expression: "tableParams.payTimes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.tableParams.refundTimes),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "refundTimes", $$v)
      },
      expression: "tableParams.refundTimes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上屏日期"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.tableParams.handDates),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "handDates", $$v)
      },
      expression: "tableParams.handDates"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择排序",
      "clearable": ""
    },
    model: {
      value: (_vm.tableParams.orderBy),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "orderBy", $$v)
      },
      expression: "tableParams.orderBy"
    }
  }, [_c('el-option', {
    key: 1,
    attrs: {
      "label": "按订单创建时间",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "按上大屏时间",
      "value": "handStartDate"
    }
  }), _vm._v(" "), _c('el-option', {
    key: 3,
    attrs: {
      "label": "按付款时间",
      "value": "payTime"
    }
  }), _vm._v(" "), _c('el-option', {
    key: 4,
    attrs: {
      "label": "按退款时间",
      "value": "refundTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款申请"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择退款申请状态",
      "clearable": ""
    },
    model: {
      value: (_vm.tableParams.refundApplyStatus),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "refundApplyStatus", $$v)
      },
      expression: "tableParams.refundApplyStatus"
    }
  }, [_c('el-option', {
    key: 1,
    attrs: {
      "label": "待处理的退款申请",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "已通过的退款申请",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    key: 3,
    attrs: {
      "label": "已关闭的退款申请",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "流程状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择流程状态",
      "clearable": ""
    },
    model: {
      value: (_vm.tableParams.processStatus),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "processStatus", $$v)
      },
      expression: "tableParams.processStatus"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": "待付款",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    key: 1,
    attrs: {
      "label": "已付款待审核",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "审核通过待锁单",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    key: 3,
    attrs: {
      "label": "审核失败待退款",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    key: 4,
    attrs: {
      "label": "已锁单待发布",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    key: 5,
    attrs: {
      "label": "已发布",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    key: 6,
    attrs: {
      "label": "已退款",
      "value": 6
    }
  }), _vm._v(" "), _c('el-option', {
    key: 7,
    attrs: {
      "label": "已关闭",
      "value": 7
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.initQueryTaskClick
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.resetParamsClick
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportOrderClick
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData.list,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderUserPhone",
      "label": "手机号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderCode",
      "label": "编号",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderStatus",
      "label": "付款状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.orderStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "effect": "dark"
          }
        }, [_vm._v("\n                        已付款\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.orderStatus == 4) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "effect": "dark"
          }
        }, [_vm._v("\n                        退款中\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.orderStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "effect": "dark"
          }
        }, [_vm._v("\n                        已退款\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.orderStatus == 0) ? _c('span', {
          staticStyle: {
            "color": "black",
            "font-weight": "600"
          }
        }, [_vm._v("待付款")]) : _vm._e(), _vm._v(" "), (scope.row.orderStatus == 3) ? _c('span', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("超时关闭")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderPicUrl",
      "label": "用户图片",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-image', {
          staticStyle: {
            "width": "100px",
            "height": "100px"
          },
          attrs: {
            "src": scope.row.orderPicUrl,
            "fit": "contain",
            "preview-src-list": [scope.row.orderPicUrl]
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handTextName",
      "label": "文字",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handDateName",
      "label": "上屏日期",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "handTimeName",
      "label": "上屏时间",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payTime",
      "label": "付款时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refundTime",
      "label": "退款时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refundApplyStatus",
      "label": "退款申请",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.refundApplyStatus == 0) ? _c('span', {
          staticStyle: {
            "color": "black",
            "font-weight": "600"
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.refundApplyStatus == 1) ? _c('span', {
          staticStyle: {
            "color": "red",
            "font-weight": "600"
          }
        }, [_vm._v("申请退款（" + _vm._s(scope.row.refundApplyTypeName) + "）")]) : _vm._e(), _vm._v(" "), (scope.row.refundApplyStatus == 2) ? _c('span', {
          staticStyle: {
            "color": "green",
            "font-weight": "600"
          }
        }, [_vm._v("退款申请已通过（" + _vm._s(scope.row.refundApplyTypeName) + "）")]) : _vm._e(), _vm._v(" "), (scope.row.refundApplyStatus == 3) ? _c('span', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("退款申请未通过（" + _vm._s(scope.row.refundApplyTypeName) + "）")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "processStatus",
      "label": "流程状态",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.processStatus == 0) ? _c('span', {
          staticStyle: {
            "color": "gray",
            "font-weight": "400"
          }
        }, [_vm._v(_vm._s(scope.row.processStatusName))]) : _vm._e(), _vm._v(" "), (scope.row.processStatus == 1) ? _c('span', {
          staticStyle: {
            "color": "#409EFF",
            "font-weight": "600",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(scope.row.processStatusName))]) : _vm._e(), _vm._v(" "), (scope.row.processStatus == 2) ? _c('span', {
          staticStyle: {
            "color": "#409EFF",
            "font-weight": "600",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(scope.row.processStatusName))]) : _vm._e(), _vm._v(" "), (scope.row.processStatus == 3) ? _c('span', {
          staticStyle: {
            "color": "red",
            "font-weight": "600",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(scope.row.processStatusName))]) : _vm._e(), _vm._v(" "), (scope.row.processStatus == 4) ? _c('span', {
          staticStyle: {
            "color": "#67C23A",
            "font-weight": "600",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(scope.row.processStatusName))]) : _vm._e(), _vm._v(" "), (scope.row.processStatus == 5) ? _c('span', {
          staticStyle: {
            "color": "#67C23A",
            "font-weight": "600",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(scope.row.processStatusName))]) : _vm._e(), _vm._v(" "), (scope.row.processStatus == 6) ? _c('span', {
          staticStyle: {
            "color": "red",
            "font-weight": "600",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(scope.row.processStatusName))]) : _vm._e(), _vm._v(" "), (scope.row.processStatus == 7) ? _c('span', {
          staticStyle: {
            "color": "black",
            "font-weight": "400",
            "font-size": "18px"
          }
        }, [_vm._v(_vm._s(scope.row.processStatusName))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.queryOrderInfoClick(scope.row)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.downloadOrderPicClick(scope.row)
            }
          }
        }, [_vm._v("下载图片")]), _vm._v(" "), _c('el-popconfirm', {
          attrs: {
            "title": "确定刷新订单状态吗？建议订单状态在有延时或异常时刷新"
          },
          on: {
            "confirm": function($event) {
              return _vm.refreshOrderClick(scope.row)
            }
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "info",
            "size": "small"
          },
          slot: "reference"
        }, [_vm._v("刷新订单")])], 1), _vm._v(" "), (scope.row.orderStatus == 1) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.openRefundDialog(scope.row)
            }
          }
        }, [_vm._v("\n                        退款\n                    ")]) : _vm._e(), _vm._v(" "), (scope.row.refundApplyStatus == 1) ? _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.openRefundApplyDialog(scope.row)
            }
          },
          slot: "reference"
        }, [_vm._v("处理退款申请")]) : _vm._e(), _vm._v(" "), (scope.row.processStatus == 1 || scope.row.processStatus == 2 || (scope.row.processStatus == 3 && scope.row.orderStatus != 2) || scope.row.processStatus == 4) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.updateProcessStatusDialog(scope.row)
            }
          }
        }, [_vm._v("\n                        审核\n                    ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.tableData.pageNum,
      "page-size": _vm.tableData.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.tableData.total
    },
    on: {
      "prev-click": function($event) {
        return _vm.changePage(-1)
      },
      "next-click": function($event) {
        return _vm.changePage(1)
      },
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "处理退款申请",
      "visible": _vm.dialogRefundApply.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogRefundApply, "dialogVisible", $event)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "600",
      "width": "100%",
      "text-align": "center",
      "line-height": "50px"
    }
  }, [_vm._v("此处仅为设置退款申请状态，如需退款请点击退款按钮")]), _vm._v(" "), _c('span', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入退款申请回复"
    },
    model: {
      value: (_vm.dialogRefundApply.refundApplyReply),
      callback: function($$v) {
        _vm.$set(_vm.dialogRefundApply, "refundApplyReply", $$v)
      },
      expression: "dialogRefundApply.refundApplyReply"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.setRefundApplyStatusClick(3)
      }
    }
  }, [_vm._v("拒绝退款申请")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.setRefundApplyStatusClick(2)
      }
    }
  }, [_vm._v("同意退款申请")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": "退款",
      "visible": _vm.refundDialog.refundDialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.refundDialog, "refundDialogVisible", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "16px",
      "font-weight": "600",
      "width": "100%",
      "text-align": "center",
      "line-height": "50px"
    }
  }, [_vm._v("确定退款吗？执行退款后无法回退")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0 0px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "20px 0 0px 0"
    }
  }, [_c('span', [_vm._v("\n                    订单付款总金额："), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "font-weight": "600",
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.refundDialog.payAmount))]), _vm._v("元\n                ")]), _vm._v("\n                ，\n                "), _c('span', [_vm._v("\n                    已退款的金额："), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "font-weight": "600",
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.refundDialog.alreadyRefundAmount))]), _vm._v("元\n                ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0 0px 0"
    }
  }, [_c('span', [_vm._v("\n                    本次最大可退款金额："), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "font-weight": "600",
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.refundDialog.refundAmountMax))]), _vm._v("元\n                ")]), _vm._v("\n                ，\n                "), _c('span', [_vm._v("\n                    最大可退款扣除30%后的金额："), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "font-weight": "600",
      "margin-right": "10px"
    }
  }, [_vm._v(_vm._s((_vm.refundDialog.refundAmountMax * 0.7).toFixed(2)))]), _vm._v("元\n                ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0 20px 0",
      "height": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "font-weight": "600",
      "margin-right": "10px"
    }
  }, [_vm._v("本次退款金额")]), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 0,
      "max": _vm.refundDialog.refundAmountMax,
      "label": "请输入退款金额",
      "step": 0.01,
      "step-strictly": ""
    },
    model: {
      value: (_vm.refundDialog.refundAmount),
      callback: function($$v) {
        _vm.$set(_vm.refundDialog, "refundAmount", $$v)
      },
      expression: "refundDialog.refundAmount"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "font-weight": "600",
      "margin-right": "10px"
    }
  }, [_vm._v("元")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0 20px 0"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入退款说明"
    },
    model: {
      value: (_vm.refundDialog.refundDesc),
      callback: function($$v) {
        _vm.$set(_vm.refundDialog, "refundDesc", $$v)
      },
      expression: "refundDialog.refundDesc"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px 0 20px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0 10px 0",
      "font-size": "18px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                退款说明快捷选项\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0 10px 0"
    }
  }, _vm._l((_vm.refundDescTemplateList), function(item, index) {
    return _c('div', {
      key: item.key,
      staticStyle: {
        "margin": "20px 0 20px 0"
      }
    }, [_c('el-link', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.refundDialog.refundDesc = item.value
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.value))])])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.refundDialog.refundDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.refundOrderClick()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTaskInfo.newUpdateTitle,
      "visible": _vm.dialogTaskInfo.newUpdateVisible,
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogTaskInfo, "newUpdateVisible", $event)
      }
    }
  }, [_c('div', {
    staticClass: "dialog-person-body"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.dialogTaskInfo.taskInfo,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单ID"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.id) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单编号"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.orderCode) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.orderUser.phone) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单IP"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.clientIp) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上屏文字"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.handText.name) + "\n                    ")]), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.handText.customTextStatus == 1) ? _c('el-form-item', {
    attrs: {
      "label": "自定义文字"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.dialogTaskInfo.taskInfo.customText))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上屏时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.handTime.name) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单金额"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.orderAmount) + " 元\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单时间"
    }
  }, [_vm._v("\n                         " + _vm._s(_vm.dialogTaskInfo.taskInfo.createdTime) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付类型"
    }
  }, [_vm._v("\n                        微信支付\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付金额"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.payAmount) + " 元\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.payTime) + "\n                    ")]), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.refundApplyStatus > 0) ? _c('el-form-item', {
    attrs: {
      "label": "退款申请状态"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.refundApplyStatusName) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.refundApplyStatus > 0) ? _c('el-form-item', {
    attrs: {
      "label": "退款申请时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.refundApplyTime) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.refundApplyStatus > 0) ? _c('el-form-item', {
    attrs: {
      "label": "退款申请类型"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.refundApplyTypeName) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.refundApplyStatus > 0) ? _c('el-form-item', {
    attrs: {
      "label": "退款申请描述"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.refundApplyDesc) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.refundApplyStatus > 0) ? _c('el-form-item', {
    attrs: {
      "label": "退款申请电话"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.refundApplyPhone) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.refundApplyStatus > 0) ? _c('el-form-item', {
    attrs: {
      "label": "退款申请回复"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dialogTaskInfo.taskInfo.refundApplyReply) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款金额"
    }
  }, [_vm._v("\n                         " + _vm._s(_vm.dialogTaskInfo.taskInfo.refundAmount) + " 元\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款说明"
    }
  }, [_vm._v("\n                         " + _vm._s(_vm.dialogTaskInfo.taskInfo.refundDesc) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款时间"
    }
  }, [_vm._v("\n                         " + _vm._s(_vm.dialogTaskInfo.taskInfo.refundTime) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单图片"
    }
  }, [_c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.dialogTaskInfo.taskInfo.orderPicUrl,
      "fit": "fit",
      "preview-src-list": [_vm.dialogTaskInfo.taskInfo.orderPicUrl]
    }
  })], 1), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.handOrderFile) ? _c('el-form-item', {
    attrs: {
      "label": "预制图片"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.dialogTaskInfo.taskInfo.orderPicUrl))])], 1) : _vm._e(), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.handOrderFile) ? _c('el-form-item', {
    attrs: {
      "label": "上部图片"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.dialogTaskInfo.taskInfo.handOrderFile.upPicUrl))])], 1) : _vm._e(), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.handOrderFile) ? _c('el-form-item', {
    attrs: {
      "label": "下部图片"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.dialogTaskInfo.taskInfo.handOrderFile.downPicUrl))])], 1) : _vm._e(), _vm._v(" "), (_vm.dialogTaskInfo.taskInfo.handOrderFile) ? _c('el-form-item', {
    attrs: {
      "label": "完整图片"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.dialogTaskInfo.taskInfo.handOrderFile.completePicUrl))])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogTaskInfo.newUpdateVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片下载",
      "visible": _vm.downloadDialog.showDownloadDialog,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.downloadDialog, "showDownloadDialog", $event)
      }
    }
  }, [_c('div', {
    staticClass: "dialog-person-body"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.downloadDialog,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户图片"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return this.window.open(_vm.downloadDialog.orderPicUrl)
      }
    }
  }, [_vm._v("下载")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预制图片"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return this.window.open(_vm.downloadDialog.purePicUrl)
      }
    }
  }, [_vm._v("下载")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上部图片"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return this.window.open(_vm.downloadDialog.upPicUrl)
      }
    }
  }, [_vm._v("下载")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下部图片"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return this.window.open(_vm.downloadDialog.downPicUrl)
      }
    }
  }, [_vm._v("下载")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "完整图片"
    }
  }, [_c('el-link', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return this.window.open(_vm.downloadDialog.completePicUrl)
      }
    }
  }, [_vm._v("下载")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.downloadDialog.showDownloadDialog = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "流程状态",
      "visible": _vm.dialogProcessStatus.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogProcessStatus, "dialogVisible", $event)
      }
    }
  }, [_c('span', [_vm._v("是否变更流程状态？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogProcessStatus.orderDetail.processStatus == 1 || _vm.dialogProcessStatus.orderDetail.processStatus == 3) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.updateProcessStatusClick(2)
      }
    }
  }, [_vm._v("审核通过待锁单")]) : _vm._e(), _vm._v(" "), (_vm.dialogProcessStatus.orderDetail.processStatus == 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.updateProcessStatusClick(3)
      }
    }
  }, [_vm._v("审核失败待退款")]) : _vm._e(), _vm._v(" "), (_vm.dialogProcessStatus.orderDetail.processStatus == 2) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.updateProcessStatusClick(4)
      }
    }
  }, [_vm._v("锁单待发布")]) : _vm._e(), _vm._v(" "), (_vm.dialogProcessStatus.orderDetail.processStatus == 4) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.updateProcessStatusClick(5)
      }
    }
  }, [_vm._v("已发布")]) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad1d647c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/order_mgr.vue
// module id = 1195
// module chunks = 2